import * as logger from 'universal-logger';
import { call, takeLatest, put } from 'redux-saga/effects';
import { omit } from 'helpers/object';
import { FILTER_NAMES } from './Search.constants';
import { loadResults, resetFilters } from './search.saga';
import { clearKeywordField } from './SearchBox/SearchBox.reducer';

const getFiltersToOmit = ({ filterKeysToClear }) => Object.values(omit(filterKeysToClear, FILTER_NAMES));

export const clearScheduleFiltersAndSearch = () => ({ type: 'searchNoResults.CLEAR_CLASS_FILTERS_AND_SEARCH' });
export const clearVenueFiltersAndSearch = () => ({ type: 'searchNoResults.CLEAR_VENUE_FILTERS_AND_SEARCH' });
export const expandSearchArea = () => ({ type: 'searchNoResults.EXPAND_SEARCH_AREA' });
export const searchNextDay = () => ({ type: 'searchNoResults.SEARCH_NEXT_DAY' });

export function* doClearClassFiltersAndSearch(client) {
  try {
    yield call(
      resetFilters,
      getFiltersToOmit({
        filterKeysToClear: ['ACTIVITY', 'TIME', 'TO_TIME', 'FROM_TIME', 'AMENITY', 'LEVEL', 'CREDITS'],
      })
    );
    yield put(clearKeywordField());
    yield call(loadResults, client);
  } catch (err) {
    logger.error('Failed while clearing filters for class search', err);
  }
}

export function* doClearVenueFiltersAndSearch(client) {
  try {
    yield call(
      resetFilters,
      getFiltersToOmit({
        filterKeysToClear: ['ACTIVITY', 'AMENITY'],
      })
    );
    yield put(clearKeywordField());
    yield call(loadResults, client);
  } catch (err) {
    logger.error('Failed while clearing filters for venue search', err);
  }
}

export function* watchSearchNoResults(client) {
  yield takeLatest(clearScheduleFiltersAndSearch().type, doClearClassFiltersAndSearch, client);
  yield takeLatest(clearVenueFiltersAndSearch().type, doClearVenueFiltersAndSearch, client);
}
